import { SEO_FILTERS_ORDER } from '@/constants';
import { SEOSegmentationSearchFilters as Filter } from '@/__generated__/globalTypes';

/**
 * Sorts a filter Array to match the order of a "sorting" array
 * @param  {string} filtersArr filter to be sorted
 * @param  {string} argServiceIdForMember serviceIdForMember ID of current segment
 * @return {Array}  sorted array
 */

const sortFilters = (filtersArr: Filter[], argServiceIdForMember: string) => {
  const sortArray = SEO_FILTERS_ORDER[argServiceIdForMember];
  try {
    return filtersArr.slice().sort((filter1: Filter, filter2: Filter) => {
      return sortArray.indexOf(filter1) - sortArray.indexOf(filter2);
    });
  } catch {
    return filtersArr;
  }
};

export default sortFilters;
